import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.overlay = this.createOverlay()
    document.body.appendChild(this.overlay)

    document.addEventListener("turbo:submit-start", this.show)
    document.addEventListener("turbo:submit-end", this.hide)
    document.addEventListener("turbo:before-fetch-request", this.showOnNavigation)
    document.addEventListener("turbo:before-fetch-response", this.hide)
    document.addEventListener("turbo:fetch-request-error", this.hide)
  }

  disconnect() {
    document.removeEventListener("turbo:submit-start", this.show)
    document.removeEventListener("turbo:submit-end", this.hide)
    document.removeEventListener("turbo:before-fetch-request", this.showOnNavigation)
    document.removeEventListener("turbo:before-fetch-response", this.hide)
    document.removeEventListener("turbo:fetch-request-error", this.hide)
    this.overlay?.remove()
  }

  showOnNavigation = (event) => {
    // Only show for full page navigations, not turbo frames
    if (event.target === document.documentElement || event.target === document) {
      this.show()
    }
  }

  show = () => {
    this.overlay.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.overlay.classList.add("opacity-100")
      this.overlay.classList.remove("opacity-0")
    })
  }

  hide = () => {
    this.overlay.classList.add("opacity-0")
    this.overlay.classList.remove("opacity-100")
    setTimeout(() => {
      this.overlay.classList.add("hidden")
    }, 200)
  }

  createOverlay() {
    const overlay = document.createElement("div")
    overlay.id = "loading-overlay"
    overlay.className = "hidden fixed inset-0 z-[9998] bg-black/50 backdrop-blur-sm flex items-center justify-center opacity-0 transition-opacity duration-200"
    overlay.innerHTML = `
      <div class="flex flex-col items-center gap-3">
        <svg class="animate-spin h-10 w-10 text-primary-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-white text-sm font-medium">Loading...</p>
      </div>
    `
    return overlay
  }
}
